import { injectable } from "inversify";
import { AppConfig } from "./AppConfig";
import { IConfigService } from "./IConfigService";

@injectable()
export class ConfigService implements IConfigService {
  bind(): AppConfig {
    return {
      platformUri: this.get("PLATFORM_URI"),
      subscriptionServiceUri: this.get("SUBSCRIPTION_SERVICE_URI")
    };
  }

  get(key: string): string {
    let extractedKey: string = key;
    if (!extractedKey.startsWith("VITE_")) {
      extractedKey = `VITE_${key}`;
    }
    const value = import.meta.env[extractedKey];
    if (value) {
      return value;
    }
    throw new Error(`No config value for key ${key}`);
  }
}
